<template>
  <div>
    <div
      v-if="LocalComposeComp"
      id="mailCompose"
      class="mail-compose"
      :class="{
        show: LocalComposeComp,
        shrink: compose.shrink,
        minimize: compose.minimize
      }"
    >
      <div class="mail-compose-dialog">
        <div class="mail-compose-header">
          <h3 class="mail-compose-title tx-white">Шуудан илгээх</h3>
          <nav class="nav nav-icon-only">
            <a
              id="mailComposeMinimize"
              @click="compose.minimize = !compose.minimize"
              class="nav-link nav-link-minimize d-none d-lg-block"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-minus"
              >
                <line x1="5" y1="12" x2="19" y2="12" />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-square"
              >
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
              </svg>
            </a>
            <a
              id="mailComposeShrink"
              @click="
                compose.minimize ? (compose.minimize = false) : '';
                compose.shrink = !compose.shrink;
              "
              class="nav-link nav-link-shrink d-none d-lg-block"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-minimize-2"
              >
                <polyline points="4 14 10 14 10 20" />
                <polyline points="20 10 14 10 14 4" />
                <line x1="14" y1="10" x2="21" y2="3" />
                <line x1="3" y1="21" x2="10" y2="14" />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-maximize-2"
              >
                <polyline points="15 3 21 3 21 9" />
                <polyline points="9 21 3 21 3 15" />
                <line x1="21" y1="3" x2="14" y2="10" />
                <line x1="3" y1="21" x2="10" y2="14" />
              </svg>
            </a>
            <a
              id="mailComposeClose"
              @click="handleLocalMailCompose({ isShow: false })"
              class="nav-link nav-link-close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-x"
              >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </a>
          </nav>
        </div>
        <div class="mail-compose-body">
          <div class="form-row align-items-center">
            <div class="col-sm">Илгээх хэрэглэгч:</div>
            <div class="col-sm-10">
              <a
                role="button"
                :class="
                  `btn  btn-${
                    postModel.userTaskIds.length > 0 ? 'success' : 'warning'
                  } btn-xs`
                "
                @click="showMention()"
              >
                <feather type="users" class="mg-r-5"></feather>
                Хэрэглэгч <sup>{{ postModel.userTaskIds.length }}</sup>
              </a>
            </div>
          </div>

          <hr class="mg-y-10" />
          <div class="form-row align-items-center">
            <div class="col-sm">Гарчиг:</div>
            <div class="col-sm-10">
              <input
                @keyup="titleChanged"
                v-model="postModel.subject"
                type="text"
                class="form-control bd-0 pd-x-0"
                placeholder="Гарчиг"
              />
            </div>
          </div>
          <div
            id="editor-container2"
            class="ht-150 mg-t-15 ql-container ql-snow"
            style="height: 150px; overflow: auto"
          >
            <summernotesimple
              :key="editorKey"
              v-model="postModel.body"
              :text="postModel.body"
              @on-blur="bodyChanged"
            ></summernotesimple>
          </div>
          <ul class="list-group">
            <li
              class="list-group-item d-flex pd-sm-x-20"
              :key="i + '_uploaded'"
              v-for="(a, i) in attachList"
            >
              <div>{{ a.title }}</div>

              <div class="mg-l-auto d-flex align-self-center">
                <nav class="nav nav-icon-only">
                  <a role="button" class="nav-link d-none d-sm-block">
                    <feather type="x" @click="removeAttach(a.id)"></feather>
                  </a>
                </nav>
              </div>
            </li>
          </ul>

          <div
            class="d-sm-flex align-items-center justify-content-between mg-t-25"
          >
            <div
              id="toolbar-container2"
              class="bd-0-f pd-0-f ql-toolbar ql-snow"
            >
              <simple-uploader
                :propBoxId="0"
                :propObjectId="'0'"
                :propObjectTypeId="30"
                @on-success="fileUploadedSimple($event)"
              >
                <div slot="trigger">
                  <span class="ql-formats">
                    <a> <feather type="paperclip"></feather>Файл хавсаргах </a>
                  </span>
                </div>
              </simple-uploader>
            </div>
            <div class="tx-13 mg-t-15 mg-sm-t-0">
              <button @click="composeMail(1)" class="btn btn-white mg-r-5">
                Ноороглох
              </button>
              <button @click="composeMail(0)" class="btn btn-primary">
                Илгээх
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- <template v-if="mention.showModal">
      <task-mention @on-mention="mentionAfter" ref="mentionMdl" :hideBtn="true" :sharingModule="8"  :showGroup="true" :sharedUsers="postModel.userTaskIds"
      whithTeam />
      </template>-->
      <mention-users
        :show="mailMention.show"
        module="localMail"
        :obj="{ id: 0 }"
        @on-mention-close="mailMention.show = false"
        @on-mention="onMention"
        :sharedUsers="postModel.userTaskIds"
      ></mention-users>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
//import { compose, postShareData, deleteMail } from "@/api/localMail";
//import { getData } from "@/api/type";

// import taskMention from "@/view/task/detail/component/coreDetail/component/taskMention.vue";

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import { request } from "@/api/all";
import "element-ui/lib/theme-chalk/index.css";
import { Message } from "element-ui";
export default {
  components: {
    Message,
    //taskMention,
    summernotesimple: () => ({
      component: import("@/components/modules/editor/summernotesimple"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    simpleUploader: () => ({
      component: import("@/components/modules/media/simpleUploader.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    mentionUsers: () => ({
      component: import("@/components/project/mention.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  data() {
    return {
      editorKey: 0,
      compose: {
        show: false,
        shrink: false,
        minimize: false
      },
      mailTypes: [],

      postModel: {
        sendFlag: 0,
        subject: "",
        body: "",
        attachmentIds: [],
        taskIds: [],
        userTaskIds: [],
        dueDate: null,
        mailTypeId: 38093,
        replyMailId: null
      },

      mention: {
        showModal: false
      },

      fileUploaderVisible: false,
      attachIds: [],

      attachList: [],
      mailMention: {
        show: false
      }
    };
  },
  computed: {
    LocalComposeComp() {
      return this.$store.state.app.localCompose.isShow;
    }
  },
  watch: {
    LocalComposeComp(newValue) {
      if (newValue) this.init();
    }
  },
  mounted() {
    require("@/assets/scss/pages/mail.scss");
  },
  methods: {
    ...mapActions(["handleLocalMailCompose"]),
    init() {
      //console.log("MAIL COMPOSE INIT FIRED");
      let obj = this.$store.state.app.localCompose;
      this.postModel.userTaskIds = obj.userIds;
      this.postModel.subject = obj.title;
      this.postModel.body = obj.body;
      this.editorKey++;
      this.attachIds = obj.attachIdsForward.map(u => {
        return u.id;
      });
      this.attachList = obj.attachIdsForward.map(u => {
        return { id: u.id, title: u.nm };
      });

      //if (this.mailTypes.length == 0) {
      // getData({ key: "sysMailType" }).then(res => {
      //   if (res != false) {
      //     this.mailTypes = res.data.types;
      //   }
      // });
      //}
    },
    clearPostModel() {
      this.postModel = {
        sendFlag: 0,
        subject: "",
        body: "",
        attachmentIds: [],
        taskIds: [],
        userTaskIds: [],
        dueDate: null,
        mailTypeId: 38093,
        replyMailId: null
      };
    },
    composeMail(m) {
      this.postModel.sendFlag = m;
      let obj = this.$store.state.app.localCompose;
      this.postModel.attachmentIds = obj.attachIds;

      if (this.postModel.userTaskIds.length > 0 || m == 1) {
        request({
          data: {
            sendFlag: this.postModel.sendFlag,
            subject: this.postModel.subject,
            body: this.postModel.body,
            attachmentIds: this.postModel.attachmentIds,
            taskIds: this.postModel.taskIds,
            dueDate: this.postModel.dueDate,
            mailTypeId: this.postModel.mailTypeId,
            replyMailId: this.postModel.replyMailId
          },
          api: { method: "POST", url: "localmail/compose" },
          store: this.$store
        }).then(res => {
          if (res != false) {
            if (obj.isDraft) {
              request({
                data: { ids: [obj.draftId] },
                api: { method: "POST", url: "LocalMail/Delete" },
                store: this.$store
              }).then(res => {
                if (res != false) {
                  request({
                    data: { ids: [obj.draftId] },
                    api: { method: "POST", url: "LocalMail/Delete" },
                    store: this.$store
                  });
                }
              });
            }
            if (m == 0) {
              let _uarr = this.postModel.userTaskIds.map(u => {
                return u.id;
              });
              //console.log('_uarr', _uarr);
              request({
                data: {
                  mailId: res.data.mailid,
                  sharedUserTaskIds: _uarr
                },
                api: { method: "post", url: "LocalMailInUser/PostShareData" },
                store: this.$store
              }).then(res => {
                if (res != false) {
                  this.clearPostModel();
                  this.$bvToast.toast("Амжилттай илгээлээ.", {
                    title: "Мэдэгдэл",
                    autoHideDelay: 3000,
                    appendToast: true,
                    variant: "success",
                    toaster: "b-toaster-bottom-left"
                  });
                  this.handleLocalMailCompose({ isShow: false });
                }
              });
            } else if (m == 1) {
              this.clearPostModel();
              this.$bvToast.toast("Амжилттай ноороглолоо.", {
                title: "Мэдэгдэл",
                autoHideDelay: 3000,
                appendToast: true,
                variant: "success",
                toaster: "b-toaster-bottom-left"
              });
              this.handleLocalMailCompose({ isShow: false });
            }
          }
        });
      } else {
        Message.success("Илгээх хэрэглэгч сонгоно уу.");
      }
    },
    showMention() {
      this.mailMention.show = true;
      // this.mention.showModal = true;
      // this.$nextTick(function() {
      //   this.$refs.mentionMdl.init();
      // });
    },
    onMention(e) {
      //console.log(e);
      this.postModel.userTaskIds = e;
      this.mailMention.show = false;
    },
    // mentionAfter(e) {
    //   this.postModel.userTaskIds = e;
    //   this.mention.showModal = false;
    //   let obj = this.$store.state.app.localCompose;
    //   obj.userIds = e;
    //   this.handleLocalMailCompose(obj);
    // },

    removeAttach(id) {
      let i = this.attachIds.map(a => a.id).indexOf(id);
      this.attachIds.splice(i, 1);
      this.attachList.splice(i, 1);
    },
    fileUploadedSimple(res) {
      //console.log(res);
      let obj = this.$store.state.app.localCompose;
      //e.uploadedAttachmentId
      obj.attachIds.push(res.uploadedAttachmentId);
      this.handleLocalMailCompose(obj);
      this.attachIds.push(res.uploadedAttachmentId);
      this.attachList.push({
        id: res.uploadedAttachmentId,
        title: res.uploadedName
      });
    },
    // handleSuccess(res) {
    //   let obj = this.$store.state.app.localCompose;
    //   obj.attachIds.push(res.response.data.uploadedAttachmentId);
    //   obj.attachIdsForward.push({
    //     id: res.response.data.uploadedAttachmentId,
    //     nm: res.response.data.uploadedName
    //   });
    //   this.handleLocalMailCompose(obj);

    //   this.attachIds.push(res.response.data.uploadedAttachmentId);
    //   this.attachList.push({
    //     id: res.response.data.uploadedAttachmentId,
    //     title: res.response.data.uploadedName
    //   });
    //   this.fileUploaderVisible = false;
    // },
    titleChanged() {
      let obj = this.$store.state.app.localCompose;
      obj.title = this.postModel.subject;
      this.handleLocalMailCompose(obj);
    },
    bodyChanged() {
      let obj = this.$store.state.app.localCompose;
      obj.body = this.postModel.body;
      this.handleLocalMailCompose(obj);
    },
    handleAttach(e) {
      let obj = this.$store.state.app.localCompose;
      obj.attachIds.push(e.id);
      obj.attachIdsForward.push({ id: e.id, nm: e.name });
      this.handleLocalMailCompose(obj);

      this.attachIds.push(e.id);
      this.attachList.push({ id: e.id, title: e.name });
      this.fileUploaderVisible = false;
    }
  }
};
</script>
<style>
.align-items-center {
  align-items: center !important;
}
.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}

.form-row > .col,
.form-row > [class*="col-"] {
  padding-right: 5px;
  padding-left: 5px;
}

@media (min-width: 576px) {
  .col-sm {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
}

@media (min-width: 576px) {
  .col-sm-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%;
  }
}

.mail-compose .form-control {
  display: block;
  width: 100%;
  padding: 0.46875rem 0.625rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #596882;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #c0ccda;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.mail-compose .custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.9375rem + 2px);
  padding: 0.46875rem 1.625rem 0.46875rem 0.625rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #596882;
  vertical-align: middle;

  background-color: #fff;
  border: 1px solid #c0ccda;
  border-radius: 0.25rem;
  appearance: none;
}
</style>
